import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../common/api";
import {
  Button,
  Container,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
  withStyles
} from "@material-ui/core";

const useStyles = theme => ({
  menu: {
    fontSize: "0.75rem"
  },
  /*column:{
        maxWidth: '110px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden' 
    },*/
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  }
});

const Reports = () => {
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [filterValues, setFilterValues] = useState({});
  const [progress, setProgress] = useState({});
  const token = localStorage.getItem("userToken");

  useEffect(() => {
    axios
      .get(api.reports().index(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        setReports(response.data);
      });
  }, []);

  const handleReportSelect = async e => {
    var reportKey = e.target.value;
    setFilterValues({});
    const report = reports[reportKey];
    await axios
      .get(api.reports().get(report.route), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        const result = response.data;
        Object.entries(result.filters).forEach(([filterKey, filter]) => {
          if (filter.type === "select") {
            const defaultFilter = filter.options.filter(
              option => option.default
            );
            if (defaultFilter.length > 0) {
              setFilterValues(prevFilterValues => ({
                ...prevFilterValues,
                [filterKey]: defaultFilter[0].id.toString()
              }));
            }
          }
        });
        setSelectedReport(result);
      });
  };

  const handleInputChange = (e, filterKey, rangeType) => {
    if (rangeType) {
      setFilterValues(prevValues => ({
        ...prevValues,
        [filterKey]: {
          ...prevValues[filterKey],
          [rangeType]: e.target.value
        }
      }));
    } else {
      setFilterValues({
        ...filterValues,
        [filterKey]: e.target.value
      });
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("report", selectedReport.route);

    Object.keys(filterValues).forEach(filterKey => {
      const value = filterValues[filterKey];
      if (value) {
        if (typeof value === "object") {
          // Si el valor es un rango de fechas
          value.from = value.from ? value.from : "";
          value.to = value.to ? value.to : "";
          formData.append(
            `filters[${filterKey}]`,
            JSON.stringify([value.from, value.to])
          );
        } else {
          formData.append(`filters[${filterKey}]`, value);
        }
      }
    });
    await axios
      .post(api.reports().post(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var progressData = response.data;
        progressData.progress = 0;
        progressData.id = response.data.progress_id;

        setProgress(progressData);
      })
      .catch(error => {
        console.error("Error al obtener el reporte:", error);
      });
  };
  useEffect(() => {
    if (progress.id) {
      const interval = setInterval(() => {
        axios
          .get(api.reports().download(progress.id), {
            headers: { Authorization: `Bearer ${token}` }
          })
          .then(response => {
            var progressData = response.data;

            if (parseInt(progressData.progress) === 100) {
              //window.open(progressData.file_url, "_blank");
              window.location.href = progressData.file_url;
              clearInterval(interval);
              setFilterValues({});
              setProgress({});
            } else {
              setProgress(progressData);
            }
          });
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [progress.id]);
  const classes = {};
  if (!reports) {
    return <div>Cargando...</div>;
  }
  return (
    <Container fluid className="main-content-container min-vh-100 px-4 pb-4">
      <div className="row mb-2 mt-2">
        <Typography variant="h6" className="col-md-3">
          Reportes disponibles
        </Typography>
        <div className="col-md-2">
          <Select
            id="report-select"
            name="report-select"
            className="mr-2"
            style={{ minWidth: 100, fontSize: "0.75rem" }}
            onClick={e => e.preventDefault()}
            onChange={e => {
              handleReportSelect(e);
            }}
          >
            {Object.keys(reports).map(key => (
              <MenuItem
                key={reports[key].id}
                value={reports[key].route}
                className={classes.menu}
                style={{ fontSize: "0.75rem" }}
              >
                {reports[key].name}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      <div className="row mb-2 mt-2">
        <div className="col-12 my-2">
          {selectedReport && (
            <div>
              <Typography variant="body1">
                Reporte: {selectedReport.name}
              </Typography>
              <Typography variant="caption">
                Descripcion:{selectedReport.description}
              </Typography>
              <form onSubmit={handleSubmit}>
                <div className="row mx-auto ">
                  {Object.keys(selectedReport.filters).map(filterKey => {
                    const filter = selectedReport.filters[filterKey];
                    if (filter.type === "text") {
                      return (
                        <div key={filterKey}>
                          <TextField
                            id={filterKey}
                            name={filterKey}
                            margin="normal"
                            className="mr-2 mt-1"
                            InputLabelProps={{
                              shrink: true
                            }}
                            value={filterValues[filterKey] || ""}
                            onChange={e => handleInputChange(e, filterKey)}
                            inputProps={{ style: { fontSize: "0.75rem" } }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Typography variant="caption">
                                    {filter.label}
                                  </Typography>
                                </InputAdornment>
                              )
                            }}
                          />
                        </div>
                      );
                    } else if (filter.type === "select") {
                      return (
                        <div key={filterKey}>
                          <TextField
                            id={filterKey}
                            name={filterKey}
                            margin="normal"
                            select
                            className="mr-2 mt-1"
                            value={filterValues[filterKey] || ""}
                            onChange={e => handleInputChange(e, filterKey)}
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{ style: { fontSize: "0.75rem" } }}
                            InputProps={{
                              style: { fontSize: "0.75rem" },
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Typography variant="caption">
                                    {filter.label}
                                  </Typography>
                                </InputAdornment>
                              )
                            }}
                          >
                            <MenuItem
                              value=""
                              className={classes.menu}
                              style={{ fontSize: "0.75rem" }}
                            >
                              <em>Todos</em>
                            </MenuItem>
                            {filter.options ? (
                              filter.options.map(option => (
                                <MenuItem
                                  key={option.id}
                                  value={option.id}
                                  className={classes.menu}
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {option.name}
                                </MenuItem>
                              ))
                            ) : (
                              <></>
                            )}
                          </TextField>
                        </div>
                      );
                    } else if (filter.type === "date_range") {
                      return (
                        <div key={filterKey} className="d-flex">
                          <TextField
                            id={`${filterKey}-from`}
                            name={`${filterKey}-from`}
                            type="datetime-local"
                            margin="normal"
                            label={`${filter.label} desde`}
                            className="mr-2 mt-1"
                            value={
                              filterValues[filterKey]
                                ? filterValues[filterKey].from
                                : ""
                            }
                            InputLabelProps={{ shrink: true }}
                            onChange={e =>
                              handleInputChange(e, filterKey, "from")
                            }
                            inputProps={{ style: { fontSize: "0.75rem" } }}
                          />
                          <TextField
                            id={`${filterKey}-to`}
                            name={`${filterKey}-to`}
                            type="datetime-local"
                            margin="normal"
                            label={`${filter.label} hasta`}
                            className="mr-2 mt-1"
                            value={
                              filterValues[filterKey]
                                ? filterValues[filterKey].to
                                : ""
                            }
                            InputLabelProps={{ shrink: true }}
                            onChange={e =>
                              handleInputChange(e, filterKey, "to")
                            }
                            inputProps={{ style: { fontSize: "0.75rem" } }}
                          />
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>

                <Button
                  className="mt-1"
                  variant="contained"
                  color="primary"
                  disabled={progress && progress.id != null ? true : false}
                  size="small"
                  style={{ fontSize: "0.75rem" }}
                  onClick={e => {
                    handleSubmit(e);
                  }}
                >
                  {progress && progress.id != null
                    ? `Generando reporte ${progress.progress}%`
                    : "Generar reporte"}
                </Button>
              </form>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default withStyles(useStyles)(Reports);
